import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Recrutement = () => {
  const sectorData = {
    title: "Recrutement",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les cabinets de recrutement, chasseur de tête ou agences d'intérim B2B doivent répondre à des besoins urgents avec réactivité. Dans ce secteur à cycle court, cibler les bons DRH, mettre en avant ses expertises sectorielles, proposer des diagnostics RH et déployer une prospection multicanale rythmée est clé pour se positionner rapidement.",
    name: "Recrutement",
    titleContext: "du recrutement et des RH",
    responseContext: "du secteur Recrutement et des RH",
    expertContext: "du secteur Recrutement"
  };

  return <SectorPage sector={sectorData} />;
};

export default Recrutement; 